module.exports = __webpack_public_path__ + "img/wordcloud-janos-ujvari.f213da5f.png";